import { browser } from "$app/environment";

type PlausibleCompletedCheckoutEvent = {
	name: "CompletedCheckout";
	props: {
		Price?: string | null;
		Description?: string;
		Coupon?: string | null;
	};
};
type PlausibleNewsletterEvent = {
	name: "Newsletter";
	props: {
		Location: string;
	};
};
type PlausibleVideoEvent = {
	name: "Video";
	props: {
		Text: string;
		Src: string;
	};
};
type PlausibleCtaEvent = {
	name: "Cta";
	props: {
		Title: string;
		Description: string;
		Href: string;
	};
};
export type PlausibleEmptySearchEvent = {
	name: "EmptySearch";
	props: {
		Query: string;
	};
};

export type PlausibleSearchEvent = {
	name: "Search";
	props: {
		Query: string;
	};
};

export type PlausibleDownloadEvent = {
	name: "Download";
	props: {
		File: string;
		Filename: string;
		Device: "MacOS" | "iOS" | "Windows";
	};
};

export type PlausibleConnectEvent = {
	name: "ConnectApp" | "ConnectSettings";
	props: {
		Device: "MacOS" | "Windows" | "Android" | "iOS" | "Router";
	};
};

export type PlausibleCertificateEvent = {
	name: "InstallCloudflareCertificate";
	props: {
		Device: "MacOS" | "Windows" | "Android" | "iOS" | "Router";
	};
};

type PlausibleEvents =
	| PlausibleCompletedCheckoutEvent
	| PlausibleVideoEvent
	| PlausibleSearchEvent
	| PlausibleEmptySearchEvent
	| PlausibleCtaEvent
	| PlausibleNewsletterEvent
	| PlausibleDownloadEvent
	| PlausibleConnectEvent
	| PlausibleCertificateEvent;

type PlausiblePageViewProps = {
	u: string;
};
export const sendPlausibleView = (props: PlausiblePageViewProps) => {
	if (typeof window?.plausible !== "function") {
		return;
	}
	//@ts-ignore
	window?.plausible("pageview", {
		...props,
	});
};
export const sendPlausibleEvent = (event: PlausibleEvents) => {
	const { name, props } = event;
	//@ts-ignore
	window?.plausible(name, {
		props: {
			...props,
		},
	});
};
